var _g, _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPolygonSurgeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2939_26866)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 8,
    fill: "#FEF0F2"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2939_26866)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2939_26866)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 12C4 9.79086 5.79086 8 8 8H32C34.2091 8 36 9.79086 36 12V50H4V12Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.61224,
    y: 10.6122,
    width: 11.102,
    height: 3.91837,
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.204,
    y: 11.9183,
    width: 7.18367,
    height: 1.30612,
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.61224,
    y: 17.1428,
    width: 26.7755,
    height: 6.53061,
    fill: "#FEE7EA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.61224,
    y: 24.9795,
    width: 26.7755,
    height: 2.61224,
    rx: 1.30612,
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.61224,
    y: 24.9795,
    width: 9.79592,
    height: 2.61224,
    rx: 1.30612,
    fill: "#46AE31"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.5306,
    cy: 34.1225,
    r: 3.91837,
    fill: "#FEF7E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8177 33.844H11.145V32.2766C11.145 31.9109 10.9469 31.8369 10.7053 32.1112L10.5311 32.3093L9.05739 33.9855C8.85494 34.214 8.93984 34.4013 9.2446 34.4013H9.91726V35.9686C9.91726 36.3343 10.1154 36.4083 10.357 36.134L10.5311 35.936L12.0049 34.2598C12.2073 34.0312 12.1224 33.844 11.8177 33.844Z",
    fill: "#F9C320"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.3265,
    cy: 34.1225,
    r: 3.91837,
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6136 33.844H20.9409V32.2766C20.9409 31.9109 20.7428 31.8369 20.5012 32.1112L20.3271 32.3093L18.8533 33.9855C18.6509 34.214 18.7358 34.4013 19.0405 34.4013H19.7132V35.9686C19.7132 36.3343 19.9113 36.4083 20.1529 36.134L20.3271 35.936L21.8008 34.2598C22.0033 34.0312 21.9184 33.844 21.6136 33.844Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.1224,
    cy: 34.1225,
    r: 3.91837,
    fill: "#E1F3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4095 33.844H30.7368V32.2766C30.7368 31.9109 30.5387 31.8369 30.2971 32.1112L30.123 32.3093L28.6492 33.9855C28.4468 34.214 28.5317 34.4013 28.8364 34.4013H29.5091V35.9686C29.5091 36.3343 29.7072 36.4083 29.9488 36.134L30.123 35.936L31.5967 34.2598C31.7992 34.0312 31.7143 33.844 31.4095 33.844Z",
    fill: "#0EA3FD"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M35.7 12.95H36V14.85H35.7V16.75H36V18.65H35.7V20.55H36V22.45H35.7V24.35H36V26.25H35.7V28.15H36V30.05H35.7V31.95H36V33.85H35.7V35.75H36V37.65H35.7V39.55H36V41.45H35.7V43.35H36V45.25H35.7V47.15H36V49.05H35.7V49.7H35V50H33V49.7H31V50H29V49.7H27V50H25V49.7H23V50H21V49.7H19V50H17V49.7H15V50H13V49.7H11V50H9V49.7H7V50H5V49.7H4.3V49.05H4V47.15H4.3V45.25H4V43.35H4.3V41.45H4V39.55H4.3V37.65H4V35.75H4.3V33.85H4V31.95H4.3V30.05H4V28.15H4.3V26.25H4V24.35H4.3V22.45H4V20.55H4.3V18.65H4V16.75H4.3V14.85H4V12.95H4.3V12C4.3 11.7525 4.32426 11.511 4.37043 11.2776L4.07614 11.2194C4.17995 10.6946 4.38642 10.2067 4.67374 9.77754L4.92303 9.94443C5.19325 9.54081 5.54081 9.19325 5.94443 8.92303L5.77754 8.67374C6.2067 8.38642 6.69457 8.17995 7.21935 8.07614L7.27757 8.37043C7.51098 8.32426 7.75251 8.3 8 8.3H9V8H11V8.3H13V8H15V8.3H17V8H19V8.3H21V8H23V8.3H25V8H27V8.3H29V8H31V8.3H32C32.2475 8.3 32.489 8.32426 32.7224 8.37043L32.7806 8.07614C33.3054 8.17995 33.7933 8.38642 34.2225 8.67374L34.0556 8.92303C34.4592 9.19325 34.8068 9.54081 35.077 9.94443L35.3263 9.77754C35.6136 10.2067 35.82 10.6946 35.9239 11.2194L35.6296 11.2776C35.6757 11.511 35.7 11.7525 35.7 12V12.95Z",
    stroke: "#FCB6C0",
    strokeWidth: 0.6,
    strokeDasharray: "2 2"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 7.5,
    stroke: "#FCB6C0"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2939_26866",
    x: -2.53061,
    y: 4.08163,
    width: 45.0612,
    height: 55.0612,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.61224
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.26531
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.4 0 0 0 0 0.4 0 0 0 0 0.4 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2939_26866"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2939_26866",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2939_26866"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 8,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2939_26866"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 12C4 9.79086 5.79086 8 8 8H32C34.2091 8 36 9.79086 36 12V50H4V12Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolygonSurgeIcon);
export default __webpack_public_path__ + "static/media/polygon-surge-icon.8e418da5800be59166718cda41445e95.svg";
export { ForwardRef as ReactComponent };